export const HardwareRef = [
    {
        ref: 'Archana, P., Sukla, L. B., & Pradhan, D. (2018). Effect of LED lights on the growth of microalgae - utkalbiotech.org. effect of LED Lights on the Growth of Microalgae - Utkalbiotech.org. Retrieved October 12, 2022, from http://www.utkalbiotech.org/notices-file/notification_1524272743.pdf ',
    },
    {
        ref: 'CHO, S. H., JI, S.-C., HUR, S. B., BAE, J., PARK, I.-S., & SONG, Y.-C. (2007). Optimum temperature and salinity conditions for growth of green algae Chlorella Ellipsoidea and Nannochloris oculata. Fisheries Science, 73(5), 1050–1056. https://doi.org/10.1111/j.1444-2906.2007.01435.x ',
    },
    {
        ref: 'Haris, N., Manan, H., Jusoh, M., Khatoon, H., Katayama, T., & Kasan, N. A. (2022). Effect of different salinity on the growth performance and proximate composition of isolated indigenous microalgae species. Aquaculture Reports, 22, 100925. https://doi.org/10.1016/j.aqrep.2021.100925',
    },
    {
        ref: 'Wang, C., Li, H., & Wei, P. (2010, August 26). [effect of ph on growth and lipid content of Chlorella vulgaris cultured in biogas slurry]. Sheng wu gong cheng xue bao = Chinese journal of biotechnology. Retrieved October 12, 2022, from https://pubmed.ncbi.nlm.nih.gov/21090111/',
    },

]
